<template>
  <div class="drill-report-comp" :class="{ 'from-range-list': fromRangeList }" v-if="reportResult">
    <drill-report-video :showTitle="false" :reportResult="reportResult" @refetch="refetchHandle" v-if="inited" />

    <drill-report-video-mode :video-mode="recordVideoMode" v-show="inited" />

    <div class="content" v-if="inited">
      <drill-report-user-info
        :reportResult="reportResult"
        :show-actions="loginStore.isAuthed"
        :show-edit-ai-result="showEditAiResult"
        @askEditAiResult="askEditAiResultHandle"
        :ai-inspect-label="aiInspectLabel"
      >
        <template #actions="params">
          <slot name="actions" v-bind="params"></slot>
        </template>
      </drill-report-user-info>

      <drill-report-score-detail :reportResult="reportResult" />

      <drill-report-jump-rope-chart
        :data="reportResult.data.interactions_power"
        :target="reportResult.data.target_speed"
        :duration="reportResult.duration"
        v-if="hasJumpRopeChart"
      />

      <drill-report-score-chart
        :data="reportResult.data.interactions_power"
        :drill="reportResult.data.drill_info"
        v-else-if="hasChart"
      />

      <drill-report-no-video-text v-if="!reportResult.hasRecordVideo" />
    </div>

    <div class="button-remove-from-list" v-if="fromRangeList">
      <kd-button class="button" size="small" @click="removeFromList" v-if="fromRangeList"> 下榜 </kd-button>
    </div>
  </div>
</template>

<script lang="ts">
import ARecord from '../../api/ARecord'
import { AHomework } from 'kuaidong-api'
import { BrowserUtil } from 'kuaidong-lib'
import { loginStore } from 'kuaidong-store'
import { HomeworkRecord } from 'kuaidong-model'
import { KdButton, KDMessageBox } from 'kuaidong-ui'
import { HomeworkCheckService } from 'kuaidong-service'
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { ReportService, ReportResult } from '../../services/ReportService'

import {
  DrillReportVideo,
  DrillReportUserInfo,
  DrillReportVideoMode,
  DrillReportScoreChart,
  DrillReportScoreDetail,
  DrillReportNoVideoText,
  DrillReportJumpRopeChart,
} from 'kuaidong-component'

@Component({
  components: {
    KdButton,
    DrillReportVideo,
    DrillReportUserInfo,
    DrillReportVideoMode,
    DrillReportScoreChart,
    DrillReportScoreDetail,
    DrillReportNoVideoText,
    DrillReportJumpRopeChart,
  },
})
export default class DrillReportComponent extends BaseComponent {
  @Prop({ type: String })
  tag!: string

  @Prop({ type: String })
  recordId!: string

  @Prop({ type: Boolean, default: false })
  showEditAiResult!: boolean

  @Prop({ type: String, default: null })
  givenAiLabel?: string

  inited = false
  reportResult: ReportResult | null = null
  belowStandard = false

  homeworkRecord: HomeworkRecord | null = null

  get loginStore() {
    return loginStore
  }

  get aiInspectLabel() {
    if (this.givenAiLabel) {
      return this.givenAiLabel
    } else {
      return this.homeworkRecord ? this.homeworkRecord.ai_inspect_label : null
    }
  }

  get fromRangeList() {
    return this.tag === 'range'
  }

  get homeworkCheckService() {
    return HomeworkCheckService
  }

  async refetchHandle() {
    this.reportResult = await ReportService.getReportById(this.recordId!)
  }

  async created() {
    this.reportResult = await ReportService.getReportById(this.recordId)
    this.reportResult.isUnderApp = false
    await this.reportResult.syncLoginUserId()
    this.inited = true

    this.fetchHomeworkRecord()

    BrowserUtil.setStopAllPlayerWhenBackgroundListener()
  }

  async fetchHomeworkRecord() {
    this.homeworkRecord = await AHomework.fetchHomeworkRecord(this.recordId)
  }

  async removeFromList() {
    const ok = await KDMessageBox.confirm('下榜后，该训练记录\n将无法参加所有的排行榜', '确认下榜？', {
      showCancelButton: true,
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      confirmButtonType: 'danger',
    })

    if (ok) {
      try {
        await ARecord.removeFromRangeList(this.recordId)
        this.toast('下榜成功')
        this.$router.go(-1)
      } catch (e) {
        this.toast('下榜失败')
      }
    }
  }

  get hasChart(): boolean {
    return !!(
      this.reportResult &&
      this.reportResult.data &&
      this.reportResult.data.interactions_power.length > 5 &&
      this.reportResult.duration > 0
    )
  }

  get hasJumpRopeChart(): boolean {
    return !!(this.reportResult && this.reportResult.isCrazyJumpRope && this.hasChart)
  }

  get recordVideoMode() {
    return this.reportResult?.data.record_video_model
  }

  askEditAiResultHandle() {
    this.$emit('askEditAiResult')
  }
}
</script>

<style lang="less">
.drill-report-comp {
  text-align: left;
  background: #f6f8fc;
  min-height: 100vh;
  padding: 0 0 36px 0;

  &.from-range-list {
    padding: 0 0 102px 0;
  }

  .content {
    padding: 16px;
    background: #fff;
  }

  .time {
    margin-left: 5.5rem;
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.39);
    line-height: 1.416667rem;
    span {
      margin-right: 0.833333rem;
    }
  }

  .button-remove-from-list {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    text-align: center;
    background: #fff;

    .button {
      width: 156px;
    }
  }
}
</style>
